<template>
  <div>
    <div class="form__counter">
      <button type="button" aria-label="Убрать один товар" @click="rem">
        <svg width="12" height="12" fill="currentColor">
          <use xlink:href="#icon-minus"></use>
        </svg>
      </button>
      <!-- eslint-disable -->
      <input type="text" v-model.number="message" @input="vert">

      <button type="button" aria-label="Добавить один товар" @click="add">
        <svg width="12" height="12" fill="currentColor">
          <use xlink:href="#icon-plus"></use>
        </svg>
      </button>
    </div>
</div>
</template>

<script>
export default {
  name: 'CounterButton',
  props: ['counter'],
  model: {
    prop: 'counter',
    event: 'changeCount',
  },
  data() {
    return {
      message: this.counter,
    };
  },
  methods: {
    vert() {
      this.$emit('changeCount', this.message);
    },
    add() {
      this.$emit('changeCount', this.message += 1);
    },
    rem() {
      if (this.message !== 0) {
        this.$emit('changeCount', this.message -= 1);
      }
    },
  },
};
</script>
